

export function listBreadcrumb() {
    return [
        {
            label: 'Formations / rencontres / parcours',
            route: { name:'list' }
        }
    ]
}

export function courseBreadcrumb(course) {
    return [
        ...listBreadcrumb(),
        {
            label: course?.title,
            url: course?.url
        }
    ]
}

export function sessionRegisterBreadcrumb(course, session) {
    return [
        ...courseBreadcrumb(course),
        {
            label: `${course?.registration_level === 'APPLICATION' ? 'Candidature' : 'Inscription'} - ${session?.title ?? ''}`,
            route: {
                name: 'session-register',
                params: {
                    courseId: course?.id,
                    session: session?.id,
                }
            }
        }
    ]
}
